// extracted by mini-css-extract-plugin
module.exports = {"container":"CardsSwiper_container__78BnG"};